import { useTranslation } from 'react-i18next';

import { CheckExpandable } from '@/components/CheckExpandable';
import { SectionHeader } from '@/components/SectionHeader';
import { Card } from '@arco-design/web-react';
import { useSyncHostTimezoneStore } from './useSyncHostTimezoneStore';

export function SyncHostTimezone() {
  const { t } = useTranslation();
  const { isSyncHostTimezoneSelected, toggleSyncHostTimezoneSelected } = useSyncHostTimezoneStore();

  const Header = (
    <SectionHeader
      inline
      title={t('components:sync.host.timezone')}
      description={t('components:synchronize.container.timezone.with.host')}
    />
  );
  return (
    <>
      <Card>
        <CheckExpandable
          label={Header}
          checked={isSyncHostTimezoneSelected}
          onChange={toggleSyncHostTimezoneSelected}
        />
      </Card>
    </>
  );
}
